var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 0.75H3.375C3.07663 0.75 2.79048 0.868526 2.5795 1.0795C2.36853 1.29048 2.25 1.57663 2.25 1.875V10.125C2.25 10.4234 2.36853 10.7095 2.5795 10.9205C2.79048 11.1315 3.07663 11.25 3.375 11.25H8.625C8.92337 11.25 9.20952 11.1315 9.4205 10.9205C9.63147 10.7095 9.75 10.4234 9.75 10.125V1.875C9.75 1.57663 9.63147 1.29048 9.4205 1.0795C9.20952 0.868526 8.92337 0.75 8.625 0.75V0.75Z",
    stroke: "#808B9F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 1.875H7.125",
    stroke: "#808B9F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43242 6.66651L6.7984 7.00718C6.79849 7.0071 6.79857 7.00701 6.79865 7.00692C6.79873 7.00683 6.79881 7.00675 6.79889 7.00666L6.43242 6.66651ZM7.44866 7.00784C7.44945 7.00866 7.45023 7.00949 7.451 7.01032L7.81592 6.66851L7.44635 7.00528C7.44713 7.00613 7.4479 7.00698 7.44866 7.00784Z",
    fill: "black",
    stroke: "#808B9F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03588 9.56586C8.21953 9.6851 8.34873 9.83216 8.42755 10H5.82354C5.90222 9.83239 6.03151 9.68527 6.21543 9.56586C6.45893 9.408 6.78266 9.3125 7.12565 9.3125C7.46979 9.3125 7.79313 9.40782 8.03535 9.56552L8.03588 9.56586ZM8.71215 10.5H5.53915L8.93015 10.4025C8.90318 10.4337 8.86968 10.4587 8.832 10.4755C8.79433 10.4924 8.75342 10.5007 8.71215 10.5Z",
    fill: "black",
    stroke: "#808B9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpfIcon);
export default __webpack_public_path__ + "static/media/cpfIcon.2be4b2166396d547fabb56dffa9541d1.svg";
export { ForwardRef as ReactComponent };